import { ModalOptionsType } from '@/context/modal-context/types'
import { useWindowSize } from 'usehooks-ts'
import { useModal } from './use-modal'

/**
 * this is just a wrapper for the useModal hook
 * that opens the sign-in modal with a specific position
 * if the screen width is greater than 768
 */

export function useSignInModal() {
  const modal = useModal()
  const { width = 0 } = useWindowSize()

  if (width > 768) {
    return {
      open: (options?: ModalOptionsType) =>
        modal.open('sign-in', { position: 'right', ...options }),
      close: () => modal.close(),
    }
  }

  return {
    open: (options?: ModalOptionsType) =>
      modal.open('sign-in', { position: 'bottom', ...options }),
    close: () => modal.close(),
  }
}
